import React from "react";
import PropTypes from "prop-types";

import { Typography } from "@mui/material";
import { NoneDisplayType, BannerDisplayType, AlertDisplayType } from "orion-components/CBComponents/Icons";
import { Translate } from "orion-components/i18n";

const propTypes = {
    displayType: PropTypes.string,
    setDisplayType: PropTypes.func,
    target: PropTypes.string
};

const defaultProps = {
    displayType: "none",
    setDisplayType: () => { }
};

const DisplayTypes = ({ displayType, setDisplayType, target }) => {

    const styles = {
        displayType: {
            margin: 10,
            textAlign: "center",
            color: "#fff",
        },
        selectedDisplayType: {
            border: "1px solid #4db5f4"
        },
        displayTypeDesc: {
            textAlign: "center",
            color: "#B5B9BE",
            width: 435,
            margin: "20px auto",
            fontSize: 14
        }
    };

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div style={styles.displayType}>
                    <span onClick={(e) => setDisplayType("none", target, e)} data-testid="orion-components-dock-notifications-center-components-display-types-span">
                        <NoneDisplayType
                            customStyles={displayType === "none" && styles.selectedDisplayType}
                        />
                    </span>
                    <Typography style={{ marginTop: 10 }}>
                        <Translate value={"global.dock.notificationsCenter.displayTypes.none"} />
                    </Typography>
                </div>
                <div style={styles.displayType}>
                    <span onClick={(e) => setDisplayType("banner", target, e)} data-testid="orion-components-dock-notifications-center-components-display-types-span-2">
                        <BannerDisplayType
                            customStyles={displayType === "banner" && styles.selectedDisplayType}
                        />
                    </span>
                    < Typography style={{ marginTop: 10 }}>
                        <Translate value={"global.dock.notificationsCenter.displayTypes.banner"} />
                    </Typography>
                </div>
                <div style={styles.displayType}>
                    <span onClick={(e) => setDisplayType("alert", target, e)} data-testid="orion-components-dock-notifications-center-components-display-types-span-3">
                        <AlertDisplayType
                            customStyles={displayType === "alert" && styles.selectedDisplayType}
                        />
                    </span>
                    <Typography style={{ marginTop: 10 }}>
                        <Translate value={"global.dock.notificationsCenter.displayTypes.alarm"} />
                    </Typography>
                </div>
            </div>
            <Typography style={styles.displayTypeDesc}>
                <Translate value={"global.dock.notificationsCenter.displayTypes.displayTypeDesc"} />
            </Typography>
        </div>
    )
};

DisplayTypes.propTypes = propTypes;
DisplayTypes.defaultProps = defaultProps;

export default DisplayTypes;